import React, { useState } from 'react';
import { customersTableColumns } from 'modules/customers/constants';
import { FormInput } from 'components/form';
import { MUITable } from 'components/shared/MUITable';
import { APIRequestPagination, APIRequestSort } from 'global';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { useCustomersPage } from 'modules/customers/hooks/useCustomersPage';
import makeStyles from '@mui/styles/makeStyles';
import { Box, InputAdornment } from '@mui/material';
import { CustomerTableRow } from 'modules/customers/types';
import { useHistory } from 'react-router-dom';
import { Search } from '@mui/icons-material';

export const CustomersListCard = () => {
  const classes = useStyles();

  const history = useHistory();

  const [searchValue, setSearchValue] = useState<string>('');
  const [sorting, setSorting] = useState<APIRequestSort>({ key: 'lastContactDate', value: 'desc' });
  const [pagination, setPagination] = useState<APIRequestPagination>({ page: 1, perPage: 15 });

  const { isLoading, customers, total } = useCustomersPage(searchValue, pagination, sorting);

  const handleRowClick = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>, row: CustomerTableRow) => {
    history.push(`/customers/${row.accountId}`);
  };

  return (
    <CardContainer>
      <FormInput
        label="Search"
        variant="outlined"
        value={searchValue}
        sx={{ maxWidth: '50%' }}
        onChange={value => setSearchValue(value)}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box className={classes.table}>
        <MUITable<CustomerTableRow>
          columns={customersTableColumns}
          isLoading={isLoading}
          tableData={customers}
          onRowClick={handleRowClick}
          hover={true}
          stickyHeader={true}
          pagination={{
            ...pagination,
            total,
            onChange: nextValue => setPagination(prev => ({ ...prev, ...nextValue })),
          }}
          sorting={{ ...sorting, onChange: setSorting }}
        />
      </Box>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  table: {
    '& .tableContainer': {
      '& .tableRow': {
        cursor: 'pointer',
      },
    },
  },
});
